var transitionDuration = 350;

function doc_keyUp(e) {
    if (e.ctrlKey && e.keyCode == 79) {
        $('#debugModal').modal('show');
    }
}

function siteFade() {
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.js-site--fade').on('click', function (e) {
        if ($(this).attr("href").indexOf("mailto:") == -1 && $(this).attr("target") != "_blank") {
            e.preventDefault();
            if ($(this).attr('href') != '#') {
                var url = $(this).attr('href');
                $('body').removeClass('render');
                setTimeout(function () {
                    window.location = url;
                }, transitionDuration);
            }
        }
    });
}

function jsLink() {
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.js-link').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('w')) {
            window.open($(this).data('href'), '_blank');
        } else {
            var url = $(this).data('href');
            $('body').removeClass('render');
            setTimeout(function () {
                window.location = url;
            }, transitionDuration);
        }
    });
}

function goBack() {
    $('body').removeClass('render');
    setTimeout(function () {
        window.history.back();
    }, 350);
}

function initializeMap(idMap, grey, infoBox) {

    if (grey === true) {
        var snazzy = [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#444444"}]
        }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {"featureType": "poi", "elementType": "labels.text", "stylers": [{"visibility": "off"}]}, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"lightness": 45}]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{"color": "#dbdbdb"}, {"visibility": "on"}]
        }];
    }

    var lat = $('#js-map-canvas').data('lat');
    var lng = $('#js-map-canvas').data('lng');

    var myLatlng = new google.maps.LatLng(lat, lng);

    var mapOptions = {
        zoom: 15,
        center: myLatlng
    };

    map = new google.maps.Map(document.getElementById(idMap), mapOptions);

    if (grey === true) {
        var mapType = new google.maps.StyledMapType(snazzy, {name: "Grayscale"});
        map.mapTypes.set('snazzy', mapType);
        map.setMapTypeId('snazzy');
    }

    if (infoBox === true) {
        var contentString = $('#js-map-canvas').data('map');

        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 200,
            maxHeight: 200
        });
    }

    var image = {
        url: '/src/images/marker.svg',
        scaledSize: new google.maps.Size(44, 60)
    };

    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        icon: image
    });

    if (infoBox === true) {
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }

    $('#js-map-canvas').children('div').css('background-color', '#f2f2f2');
}

function initMapPageSpeed(){
    // Google maps
    if ($('#js-map-canvas').length > 0) {
        initializeMap('js-map-canvas', true, false);
    }
}


$('document').ready(function () {
    // Width
    var width = window.innerWidth || document.body.clientWidth;

    // Detect language
    var userLang = navigator.language;
    $('html').attr('lang', userLang);

    // Debug mode
    if ($('pre').length > 0) {
        $('pre').each(function (e) {
            $('#debugModal .modal-body').append($(this));
        });
        $('#debugModal').modal('show');
        document.addEventListener('keyup', doc_keyUp, false);
    }

    // Fade in / fade out page transition
    if ($('.js-site--fade').length > 0) {
        siteFade();
    }

    if ($('.js-link').length > 0) {
        jsLink();
    }

    // Check touch devices
    var checkMobile = function () {
        var isTouch = ('ontouchstart' in document.documentElement);
        if (isTouch) {
            $('html').addClass('touch');
        } else {
            $('html').addClass('no-touch');
        }
    };
    checkMobile();

    // Slider
    if ($('.js-slider-testimonials').length > 0) {
        $('.js-slider-testimonials').each(function () {
            var $this = $(this);

            var sliderTestimonials = new Swiper($this, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
            });
        });
    }

    if ($('.js-slider-images').length > 0) {
        $('.js-slider-images').each(function () {
            var $this = $(this);

            var sliderId = $(this).data('slider');
            var nextEl = '.js-slider-button-next-' + sliderId;
            var prevEl = '.js-slider-button-prev-' + sliderId;
            var progressBar = '.js-slider-pagination-' + sliderId;

            var sliderImages = new Swiper($this, {
                //loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                pagination: {
                    el: progressBar,
                    type: 'progressbar',
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                }
            });

            sliderImages.on('slideChange', function () {
                $this.parents('.js-images-wrapper').find('.slider-bar_count .js-count').html(sliderImages.activeIndex + 1);
                $this.parents('.js-images-wrapper').find('.js-overlay-text, .animation-fade_top, .animation-scale_x, .animation-fade_bottom').removeClass('animation-active');

                if (sliderImages.activeIndex + 1 > 1) {
                    $this.parents('.js-images-wrapper').find('.js-overlay-text, .animation-fade_top, .animation-scale_x, .animation-fade_bottom').addClass('animation-active');
                }
            });
        });
    }

    if ($('.js-slider-header').length > 0) {
        $('.js-slider-header').each(function () {
            var $this = $(this);

            var sliderId = $(this).data('slider');
            var nextEl = '.js-slider-button-next-' + sliderId;
            var prevEl = '.js-slider-button-prev-' + sliderId;

            var sliderHeader = new Swiper($this, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                }
            });
        });
    }

    // Lightgallery video
    if ($('.js-lightgallery-video').length > 0) {

        if ($('.js-color-vimeo').length > 0) {
            function RGBtoHEX(rgb, hash) {
                var parts = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                delete (parts[0]);
                for (var i = 1; i <= 3; ++i) {
                    parts[i] = parseInt(parts[i]).toString(16);
                    if (parts[i].length == 1) parts[i] = '0' + parts[i];
                }
                return (hash == true ? '#' : '') + parts.join('').toUpperCase();
            }
            var vimeoColor = RGBtoHEX($('.js-color-vimeo').css('color'));
        }

        $('.js-lightgallery-video').lightGallery({
            counter: false,
            download: false,
            mode: 'lg-fade',
            cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
            selector: '.js-video',
            getCaptionFromTitleOrAlt: false,
            youtubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                controls: 1
            },
            vimeoPlayerParams: {
                byline: 0,
                portrait: 0,
                color: vimeoColor
            }
        });
    }

    // Lightgallery slider
    if ($('.js-lightgallery-slider').length > 0) {
        $('.js-lightgallery-slider').lightGallery({
            counter: false,
            download: false,
            mode: 'lg-fade',
            cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
            selector: '.js-gallery',
        });
    }

    // Parallax
    if ($('#scene').length > 0) {
        var scene = document.getElementById('scene');
        var parallaxInstance = new Parallax(scene);
    }

    // Cookies
    $.fn.queueAddClass = function(className) {
        this.queue('fx', function(next) {
            $(this).addClass(className);
            next();
        });
        return this;
    };

    if ($.cookie('cookies-valid')) {
        $('.bs-cookies').addClass('bs-cookies-hide hidden').removeClass('bs-cookies-show');
    } else {
        $('.bs-cookies').addClass('bs-cookies-show').removeClass('bs-cookies-hide hidden');
    }

    $('#bs-cookies-dismiss').click(function (e) {
        e.preventDefault();
        $.cookie('cookies-valid', true, {expires: 3650, path: '/'});
        $('.bs-cookies').addClass('bs-cookies-hide').removeClass('bs-cookies-show').delay(300).queueAddClass('hidden');
    });

    // MMenu - menu responsive
    if ($('#js-responsive-menu').length > 0) {
        var $menu = $('#js-responsive-menu').mmenu({
            navbar: {
                add: false,
                title: 'Menu'
            },
            navbars: [
                {
                    "position": "top",
                },
                {
                    "position": "bottom",
                    "content": [
                        "<a class='fas fa-envelope' href='mailto:"+ $("#js-responsive-menu").data('email') +"'></a>",
                        "<a class='fas fa-phone-alt mr-1' href='tel:"+ $("#js-responsive-menu").data('phone') +"'></a>",
                        // "<a class='fab fa-facebook-f' target='_blank' href='"+ $("#js-responsive-menu").data('facebook') +"'></a>",
                        "<a class='fas fa-map-marker-alt' target='_blank' href='"+ $("#js-responsive-menu").data('address') +"'></a>"
                    ]
                }
            ],
            'extensions': [
                'position-right',
                'pagedim-black'
            ]
        }, {
            offCanvas: {
                pageSelector: "#main-content"
            }
        });

        var $mmenuIcon = $('.js-burger-nav-button');
        var $mmenuAPI = $menu.data("mmenu");

        $mmenuIcon.on('click', function () {
            if ($('html').hasClass('mm-wrapper_opened')) {
                $mmenuAPI.close();
            } else {
                $mmenuAPI.open();
            }
        });

        $mmenuAPI.bind('open:start', function () {
            $mmenuIcon.addClass('is-active');
            if (!$('.header').hasClass('scrolled')) {
                $('.header').addClass('is-opening');
            }
        });
        $mmenuAPI.bind('close:start', function () {
            $mmenuIcon.removeClass('is-active');
            if (!$('.header').hasClass('scrolled')) {
                $('.header').removeClass('is-opening');
            }
        });
    }

    // Headroom
    if ($('.header-main').length > 0 && width > 1200) {
        var navbar = document.querySelector('.header-main');
        var offsetElement = 150;

        new Headroom(navbar, {
            'offset' : offsetElement,
            'classes': {
                initial : "headroom",
                // when scrolling up
                pinned : "headroom--pinned",
                // when scrolling down
                unpinned : "headroom--unpinned",
                // when above offset
                top : "headroom--top",
                // when below offset
                notTop : "headroom--not-top"
            }
        }).init();
    }

    // Margin to boxes
    if ($('.js-add-m').length > 0 && width > 991) {

        $('.js-outer-h').each(function (i) {

          var outerH = $(this).height();
          var innerH = $(this).find('.js-inner-h').height();

          var marginH = outerH - innerH;

          if($(this).find('.div-2').length > 0){
              marginH = marginH / 2;
          }

          $(this).find('.js-add-m').attr('style', 'margin-top: ' + marginH + 'px !important');

        })


        // $('.js-outer-h').height();
        //
        // var outerH = $('.js-outer-h').height();
        // var innerH = $('.js-inner-h').height();
        //
        // var marginH = outerH - innerH;
        //
        // $('.js-add-m').attr('style', 'margin-top: ' + marginH + 'px !important');
    }

    // Selectpicker
    var selectPicker = $('.selectpicker').selectpicker({
        template: {
            caret: '<span class="caret"></span>'
        }
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        $('.selectpicker').selectpicker('mobile');
    }

    // Articlelist ajax
    if ($('.articlelist').length > 0) {

        // Submit form on change function
        $('body').on('change', '.articlelist .article-filter form.article-filter-fields .form-group select', function () {
            $('.articlelist .article-filter form.article-filter-fields').submit();
        });

        // Ajax blog form
        $('body').on('submit', '.articlelist .article-filter form.article-filter-fields', function (e) {
            e.preventDefault();
            var callId = Math.round(Math.random() * 10000);
            var url = $(this).attr('action');
            var params = $(this).serializeArray();
            lastCall = callId;
            $('.main-loader').addClass('load');
            $.get(url, params, function (data) {
                $('.articlelist .article-container').fadeOut(50, function () {
                    $('.articlelist .article-container').replaceWith($(data).find('.articlelist .article-container'));
                    $('.articlelist .article-container .article-container-items .article-item').each(function (i) {
                        var me = this;
                        setTimeout(function () {
                            $(me).css('opacity', '100');
                        }, 30 * i);
                    });
                    if (history.pushState) {
                        history.pushState({
                                type: 'listing',
                                url: url + (params ? "&" + $.param(params) : "")
                            },
                            $('title').text(),
                            url + (params ? "?" + $.param(params) : "")
                        );
                    }
                });
                $('.main-loader').removeClass('load');
            });
        });

        // Load more function button
        $('body').on('click', '.articlelist .load-more a', (function (e) {
            e.preventDefault();
            $('.main-loader').addClass('load');
            var mediaPaginationUrl = $(this).attr('href');
            $.get(mediaPaginationUrl, [], function (data) {
                $('.articlelist .load-more').replaceWith($(data).find('.articlelist .load-more'));
                $('.main-loader').removeClass('load');
                $(data).find('.articlelist .article-container .article-container-items .article-item').each(function () {
                    $('.article-container-items').append(this);
                });
            });
        }));
    }

    const LetzshopScript = document.createElement('script');
    setTimeout(function(){
        LetzshopScript.src = 'https://content.letzshop.lu/app.js?vendorName=eisleker-miwwelstrooss&Hpos=left&Vpos=bottom&Lang=fr';
        document.body.appendChild(LetzshopScript);
        $('.navbar-cookies').addClass('bottom-letzshop-resp');
    }, 5000);

    $(window).scroll(function(){
        if ($(window).scrollTop() >= 56 && width > 991) {
            $('.header-main').addClass('header-main-fixed');
        }
        else {
            $('.header-main').removeClass('header-main-fixed');
        }
    });
});

// Validation form BS4
(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();